import { render, staticRenderFns } from "./WccOrderInsert.vue?vue&type=template&id=5f1662cc&scoped=true&"
import script from "./WccOrderInsert.vue?vue&type=script&lang=js&"
export * from "./WccOrderInsert.vue?vue&type=script&lang=js&"
import style0 from "./WccOrderInsert.vue?vue&type=style&index=0&id=5f1662cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1662cc",
  null
  
)

export default component.exports